import { BasketPanel } from "../components/Basket/Panel.tsx";

export default BasketPanel;